import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default function OZoneTable({
	tableConfig,
	description,
	className,
}) {
	return (
		<article className={`o-section-household-story o-section--atex-zone ${className}`}>
			<p className="story-article">
				<FormattedMessage id={description} />
			</p>
			<div className="zone-table--wrapper">
				<table className="zone-table">
					<tr className="zone-header">
						{tableConfig.header.map(item => (
							<th key={item.id} className={`header-cell ${item.className}`}>
								<p className="small-link"><FormattedMessage id={item.label} /></p>
							</th>))}
					</tr>
					{tableConfig.rows.map(row => (
						<tr key={row[0]} className="zone-row">
							{row.map(item => <td key={item}><p className="small-link">{item}</p></td>)}
						</tr>))}
				</table>
			</div>
		</article>
	);
}

OZoneTable.propTypes = {
	tableConfig: PropTypes.any.isRequired,
	description: PropTypes.string.isRequired,
	className: PropTypes.string,
};

OZoneTable.defaultProps = {
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.zone-table.js